import { SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "../sidebar/app-sidebar";
import { DashboardHeader } from "./header";

export default function DashboardLayoutWrapper({ children }: { children: React.ReactNode }) {
  return (
    <>
      <AppSidebar id="main-sidebar" />
      <SidebarInset
        className="flex flex-col border md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-0"
        role="main"
      >
        {/* <DashboardHeader /> */}
        <div
          className="flex-1 overflow-auto p-2"
          aria-label="Dashboard content"
        >
          {children}
        </div>
      </SidebarInset>
    </>
  );
}